import React, { useEffect, useState } from "react";
import { useAxios } from "../../../common_nextgen/axios/AxiosHelper";
import useCustomNavigate from "../../../common_nextgen/common_components/Navigation/NextGenNavigation";
import getBackendUrl from "../../../environment/BackendService";
import { fetchDropdownValues } from "../../../common_nextgen/common_components/dropdown/DropdownHelper";
import { useLocation } from "react-router-dom";
import { ROUTE_PATHS } from "../../../common_nextgen/utils/Constants";
import { useToast } from "../../../common_nextgen/hooks/ToastContext";
import { downloadCSV } from "../../../common_nextgen/utils/UtilFunctions";

const useOutOfPocketMaxScheduleStepsDetailExt = () => {
  const {
    OUT_OF_POCKET_MAX_SCHEDULE_STEPS,
    DISPLAY_OUT_OF_POCKET_MAX_SCHEDULE_STEPS_DETAILS_EXT,
    EDIT_OUT_OF_POCKET_MAX_SCHEDULE_STEPS_DETAILS_EXT,
    ADD_OUT_OF_POCKET_MAX_SCHEDULE_STEPS_DETAILS_EXT,
    OUT_OF_POCKET_MAX_SCHEDULE,
  } = ROUTE_PATHS;
  const [data, setData] = useState([]);
  const location = useLocation();
  const { axios_helper_no_header } = useAxios();

  /* const {
    selectedSteps = [],
    previousScreen = OUT_OF_POCKET_MAX_SCHEDULE_STEPS,
    currentIndex: initialIndex = 0,
    description,
    scheduleName,
  } = location.state || {}; */
  const { state: stateVal } = location;
  let [currentState = {}] = [...stateVal].reverse();
  const previousState = [...stateVal];
  previousState.splice(stateVal.length - 1, 1);
  let {
    selectedSteps = [],
    previousScreen = OUT_OF_POCKET_MAX_SCHEDULE,
    currentIndex: initialIndex = 0,
    description,
    scheduleName,
  } = currentState;

  const [currentIndex, setCurrentIndex] = useState(initialIndex);
  const [paramsData, setParamsData] = useState({
    opcScheduleName: scheduleName,
    description: description,
    opdStepNumber: selectedSteps[initialIndex].opdStepNumber,
  });
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rowData, setRowData] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);
  const navigateToPage = useCustomNavigate();
  const [dropdownValues, setDropdownValues] = useState({});
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("no");
  const toast = useToast();

  const screen_title = "OOP Maximum Schedule Step Detail Extension";
  const screenNumber = "RCOPE001";
  const formFields = [
    {
      fieldLabel: "Schedule",
      name: "opcScheduleName",
      label: "Schedule",
      type: "text",
      value: "",
      maxLength: 10,
      fieldNature: "readOnly",
    },
    {
      fieldLabel: "Description",
      name: "description",
      label: "Description",
      type: "text",
      value: "",
      maxLength: 40,
      fieldNature: "readOnly",
    },
    {
      fieldLabel: "Step",
      name: "opdStepNumber",
      label: "Step",
      type: "text",
      value: "",
      maxLength: 2,
      fieldNature: "readOnly",
    },
  ];

  const dropdownOptions = [];

  const dropdownCondition = {
    dropDowns: dropdownOptions.map((item) => item.field_label + item.condition),
  };

  const leftButtons = [
    {
      button_label: "Back",
      button_handeler: () => {
        if (currentIndex < selectedSteps.length - 1) {
          setCurrentIndex((prevIndex) => prevIndex + 1);
        } else {
          navigateToPage(previousScreen, previousState);
        }
      },
      button_key: "F12",
    },
  ];

  const ctaButtons = [
    {
      button_label: "Add OOP Maximum Schedule Step Detail Extension",
      button_handeler: () => {
        console.log("paramsData", paramsData);
        navigateToPage(ADD_OUT_OF_POCKET_MAX_SCHEDULE_STEPS_DETAILS_EXT, [
          ...previousState,
          { ...currentState, currentIndex },
          {
            previousScreen: location.pathname,
            opcScheduleName: paramsData.opcScheduleName,
            opdStepNumber: paramsData.opdStepNumber,
          },
        ]);
      },
      button_key: "F6",
    },
    {
      button_label: "Export as CSV",
      button_handeler: () => {
        exportAsCSV();
      },
      button_key: "",
    },
  ];

  const menuOptions = [
    {
      label: "Edit",
      icon: <span className="material-icons">edit</span>,
      command: () => {
        navigateToPage(EDIT_OUT_OF_POCKET_MAX_SCHEDULE_STEPS_DETAILS_EXT, [
          ...previousState,
          { ...currentState, currentIndex },
          {
            selectedDetailExtensions: selectedRows.length
              ? selectedRows
              : [rowData],
            previousScreen: location.pathname,
            currentIndex: 0,
            opcScheduleName: paramsData.opcScheduleName,
            opdStepNumber: paramsData.opdStepNumber,
            // opeExtensionSource: rowData.opeExtensionSource,
            // opeExtensionPhase: rowData.opeExtensionPhase,
          },
        ]);
      },
    },
    {
      label: "Delete",
      icon: <span className="material-icons">delete</span>,
      command: () => {
        openConfirmationModal();
      },
    },
    {
      label: "Display",
      icon: <span className="material-icons">visibility</span>,
      command: () => {
        navigateToPage(DISPLAY_OUT_OF_POCKET_MAX_SCHEDULE_STEPS_DETAILS_EXT, [
          ...previousState,
          { ...currentState, currentIndex },
          {
            selectedDetailExtensions: selectedRows.length
              ? selectedRows
              : [rowData],
            previousScreen: location.pathname,
            currentIndex: 0,
            opcScheduleName: paramsData.opcScheduleName,
            opdStepNumber: paramsData.opdStepNumber,
            //opeExtensionSource: rowData.opeExtensionSource,
            //opeExtensionPhase: rowData.opeExtensionPhase,
          },
        ]);
      },
    },
  ];

  const columnDef = [
    {
      header: "Source",
      field: "opeExtensionSource",
    },
    {
      header: "Phase",
      field: "opeExtensionPhase",
    },
    {
      header: "Brand Flat Amount",
      field: "opeBrandFlatAmount",
    },
    {
      header: "Generic Flat Amount",
      field: "opeGenericFlatAmount",
    },
    {
      header: "Brand Percent Amount",
      field: "opeBrandPercentAmt",
    },
    {
      header: "Generic Percent Amount",
      field: "opeGenericPercentAmt",
    },
    {
      header: "F/% Comparison",
      field: "opeFlatPctComparison",
    },
  ];

  const parmKey = "schedule";

  const fetchData = async () => {
    const page = first / rows;
    try {
      const raw_response = await axios_helper_no_header(
        "GET",
        `api/opeOutPoktSchDtlExt`,
        null,
        {
          page: page,
          size: rows,
          ...paramsData,
        }
      );
      const response = raw_response.responseData;
      const pageResponse = raw_response.responsePaginationDTO;
      if (response.length === 0) {
        setData([]);
        setTotalRecords(0);
        toast.current.show({
          severity: "info",
          summary: "",
          detail: response.responseStatus.message,
          life: 3000,
        });
      } else {
        setData(response);
        setTotalRecords(pageResponse.totalRecords);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setData([]);
      setTotalRecords(0);
    }
  };

  const fetchDropdownData = async (dataDropdown) => {
    try {
      const response = await fetchDropdownValues(dataDropdown);
      setDropdownValues(response);
    } catch (error) {
      console.error("Error fetching dropdown values:", error);
    }
  };

  useEffect(() => {
    fetchDropdownData(dropdownCondition);
  }, []);

  useEffect(() => {
    fetchData();
  }, [paramsData, rows, currentPage]);

  const onPageChange = (event) => {
    setFirst(event.first);
    setCurrentPage(event.page);
    setRows(event.rows);
  };

  const openConfirmationModal = () => {
    setIsConfirmationModalOpen(true);
  };

  const closeConfirmationModal = () => {
    setIsConfirmationModalOpen(false);
    setSelectedOption("no");
  };

  const deleteOopMaximumScheduleStep = () => {
    if (selectedOption === "yes") {
      const params = {
        opcScheduleName: paramsData.opcScheduleName,
        opdStepNumber: paramsData.opdStepNumber,
        opeExtensionSource: rowData.opeExtensionSource,
        opeExtensionPhase: rowData.opeExtensionPhase,
      };
      axios_helper_no_header("DELETE", "api/opeOutPoktSchDtlExt", null, params)
        .then((response) => {
          const updatedItems = data.filter(
            (item) => item.schedule !== rowData.schedule
          );
          if (currentPage > 0) {
            setFirst(0);
            setCurrentPage(0);
          } else {
            fetchData();
          }
          toast.current.show({
            severity: "success",
            summary: "",
            detail: response.responseStatus.message,
            life: 3000,
          });
          closeConfirmationModal();
          if (currentPage > 0) {
            setFirst(0);
            setCurrentPage(0);
          } else {
            fetchData();
          }
        })
        .catch((error) => {
          console.error("There was an error deleting the data!", error);
          const errorMessage =
            error.data?.responseStatus?.message || error.message;
          toast.current.show({
            severity: "error",
            summary: "",
            detail: errorMessage,
            life: 3000,
          });
          closeConfirmationModal();
        });
    } else {
      closeConfirmationModal();
    }
  };

  const exportAsCSV = async () => {
    const queryParams = { ...paramsData };
    try {
      const response = await axios_helper_no_header(
        "GET",
        "api/opeOutPoktSchDtlExt/exportcsv",
        null,
        queryParams,
        "blob"
      );
      downloadCSV(response);
    } catch (error) {
      console.error("Error exporting as CSV:", error);
      toast.current.show({
        severity: "error",
        summary: "",
        detail: "Failed to export CSV. Please try again.",
        life: 3000,
      });
    }
  };

  useEffect(() => {
    setParamsData({
      ...paramsData,
      opdStepNumber: selectedSteps[currentIndex].opdStepNumber,
    });
  }, [currentIndex]);

  const updateParamData = (data) => {
    setFirst(0);
    setCurrentPage(0);
    setParamsData(data);
  };

  return {
    screenNumber,
    screen_title,
    formFields,
    dropdownValues,
    paramsData,
    updateParamData,
    ctaButtons,
    data,
    parmKey,
    menuOptions,
    columnDef,
    setRowData,
    selectedRows,
    setSelectedRows,
    first,
    rows,
    totalRecords,
    currentPage,
    onPageChange,
    isConfirmationModalOpen,
    closeConfirmationModal,
    deleteOopMaximumScheduleStep,
    setSelectedOption,
    leftButtons,
  };
};

export default useOutOfPocketMaxScheduleStepsDetailExt;
